module.exports = __webpack_public_path__ + "img/鎏金面膜+珍银面膜_02.3c9d1590.jpg";